<template>
  <article class="service-card mb-4">
    <div class="service-card-wrapper d-flex flex-column h-100">
      <div class="d-flex align-items-center icons w-100">
        <img style="width: 60px; height: 60px" :src="card.icon" :alt="card.iconAlt" width="60" height="60" />
        <RectAngleShape class="w-100" />
      </div>
      <h3>{{card.title }}</h3>
      <p class="flex-stretch">{{ card.description }}</p>
      <ButtonTransparent class="service-card__btn" hyperlink :href="card.button.link" :text="card.button.title" />
    </div>
  </article>
</template>

<script>
import ClipboardIcon from "@/assets/icons/clipboard-icon";
import RectAngleShape from "@/components/common/RectAngleShape";
import ButtonTransparent from "@/components/common/ButtonTransparent";
export default {
  components: {ButtonTransparent, RectAngleShape, ClipboardIcon},
  props: {
    card: {
      icon: String,
      iconAlt: String,
      title: String,
      description: String,
      button: {
        title: String,
        link: String
      }
    }
  }
}
</script>
